import React from "react";
import logo from "../../../assets/images/spryhub-logo.png";

const links = [
  { label: "Find Job" },
  { label: "Companies" },
  { label: "About" },
  { label: "Privacy Policy", dropdown: true },
  { label: "Terms of use" },
  { label: "Advertising" },
  { label: "Business Services", dropdown: true },
  { label: "Get the App" },
  { label: "More" },
];

const FooterCard = () => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <div className="flex items-center gap-2 text-gray-700">
          <img src={logo} alt="logo" className="h-4 w-auto" />
          <span className="text-xs">
            &copy; {new Date().getFullYear()} SpryHub. All rights reserved.
          </span>
        </div>
        <p className="text-xs text-gray-700">
          At SpryHub, we are dedicated to fostering connections that matter. As
          a fast-growing social platform, we empower individuals, brands, and
          communities to share stories, build relationships, and discover new
          ways to engage with the world.
        </p>
      </div>

      {/* <div className="flex flex-wrap gap-x-5 gap-y-2">
                {links.map((item, index) => (
                    <span
                        key={index}
                        className="hover:underline cursor-pointer text-xs text-gray-700"
                    >
                        {item.label}
                        {item.dropdown && <span className="ml-1">▾</span>}
                    </span>
                ))}
            </div> */}
    </div>
  );
};

export default FooterCard;
